import React, { FunctionComponent } from 'react';
import { Button, Form, Icon, Modal } from 'semantic-ui-react';
import FormField from 'components/form-field/form-field';
import { useFormikContext } from 'formik';
import { CompanyFormFields } from 'modules/company/types/companyFormFields.type';

type Props = {
  isOpen: boolean;
  onValidate: () => void;
  onClose: () => void;
};

export const AddressModificationModal: FunctionComponent<Props> = ({
  isOpen,
  onClose,
  onValidate,
}) => {
  const { errors } = useFormikContext<CompanyFormFields>();

  const hasError =
    !!errors.address?.streetAddress ||
    !!errors.address?.postalCode ||
    !!errors.address?.city;
  return (
    <Modal
      onClose={onClose}
      open={isOpen}
      closeOnDimmerClick={false}
      closeOnEscape={false}
      closeIcon
    >
      <Modal.Header>Édition de l&apos;adresse du pro</Modal.Header>
      <Modal.Content>
        <Form>
          <FormField
            name="address.streetAddress"
            type="text"
            label="Adresse"
            required
          />
          <FormField
            name="address.postalCode"
            type="text"
            label="Code postal"
            required
          />
          <FormField name="address.city" type="text" label="Ville" required />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Annuler</Button>
        <Button primary type="button" disabled={hasError} onClick={onValidate}>
          <Icon name="check" />
          Valider
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
